<div>
  <div class="modal fade show" tabindex="-1" aria-labelledby="business-partners-modalLabel" aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
    [ngClass]="{'expanded':isExpanded}">

    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header float-end">
          <div class="d-flex w-100">
            <div class="me-2 flex-fill">
              <h2 class="modal-title mb-0 item-id">{{ sales ? 'Sales Representatives' : 'Select Reporter' }}</h2>
            </div>
            <div class="btns-header">
              <button class="header-icon close p-0 m-0" (click)="close()" aria-label="Close">
                  <i class="fas fa-times" title="Close Popup"></i>
              </button>
              <button class="header-icon close p-0 m-0" (click)="expandCollapse()" [attr.aria-label]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'">
                  <i class="fas mx-2"
                      [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                      [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="modal-body pt-0">
          <div class="reporters-grid px-3 pt-1">
            <inavista-grid #reportersGrid
              [config]="gridConfig"
              [actionIcons]="actionIcons"
              (actionIconClick)="onActionIconClick($event)"
              (hyperlinkClick)="onHyperlinkClick($event)"
              (exportRequested)="onExportRequested()" />
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger close-modal px-2" (click)="close()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showUserProfilePopup) {
  <app-user-profile-popup
  [userProfile]="userProfile"
  (closePopup)="showUserProfilePopup = false;"
  ></app-user-profile-popup>
}
